import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CURRENCY_OPTIONS } from '../investments/investmentConstants';

/** Shared header fields for every continuity asset form. */
const SharedAssetFields = ({ value, onChange }) => (
  <div className="space-y-4">
    <div>
      <Label htmlFor="ca-nickname">Asset Name *</Label>
      <Input
        id="ca-nickname"
        data-testid="ca-nickname-input"
        value={value.nickname || ''}
        onChange={(e) => onChange({ ...value, nickname: e.target.value })}
        placeholder="e.g. Family Range Rover, Aviva Life Policy, Sunseeker 68"
        required
      />
    </div>

    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label htmlFor="ca-value">Estimated value (optional)</Label>
        <Input
          id="ca-value"
          data-testid="ca-value-input"
          type="number"
          value={value.estimated_value ?? ''}
          onChange={(e) => onChange({ ...value, estimated_value: e.target.value ? Number(e.target.value) : null })}
          placeholder="0"
        />
      </div>
      <div>
        <Label htmlFor="ca-currency">Currency</Label>
        <Select
          value={value.currency || ''}
          onValueChange={(v) => onChange({ ...value, currency: v })}
        >
          <SelectTrigger id="ca-currency" data-testid="ca-currency-select">
            <SelectValue placeholder="Pick a currency" />
          </SelectTrigger>
          <SelectContent className="max-h-64">
            {CURRENCY_OPTIONS.map((c) => (
              <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>

    <div className="flex items-center justify-between rounded-lg border border-slate-200 p-3">
      <div>
        <Label className="text-sm">Include in Net Worth (Portfolio Clarity)</Label>
        <p className="text-xs text-slate-500 mt-0.5">
          Adds this asset&rsquo;s value to your Statement of Net Worth. Loans reduce it automatically.
        </p>
      </div>
      <Switch
        checked={!!value.include_in_net_worth}
        onCheckedChange={(v) => onChange({ ...value, include_in_net_worth: v })}
        data-testid="ca-networth-toggle"
      />
    </div>

    <div>
      <Label htmlFor="ca-notes">Notes (optional)</Label>
      <Textarea
        id="ca-notes"
        data-testid="ca-notes-input"
        value={value.notes || ''}
        onChange={(e) => onChange({ ...value, notes: e.target.value })}
        placeholder="Anything the people you trust should know — location of documents, agent contact, etc."
        rows={3}
      />
    </div>
  </div>
);

export default SharedAssetFields;
